const utils = require('../../../lib/utils')

module.exports = {
	model: {
		options: {}
	},

	events: {
		click: function(event){
			event.preventDefault();
			event.stopImmediatePropagation();

			var component = event.data.component;
			component.performAndStoreAction(
				'routeOptionsModal',
				component.prepareAction(
					'showEdit_routeOptions',
					undefined,
					{
						options: event.data.component.model.options
					}
				)
			);
		}
	},

	methods: {
		dataDealer: function(){
			var self = this;
			this.closest('templates_propertiesForms_routePropertiesForm', function(form){
				if(form.resourceData && form.resourceData.data && form.resourceData.data.attributes){
					self.model.options = form.resourceData;
				}
			});
		}
	},

	hooks: {
		async onDecision($element, options){
			// TODO: CLEANUP NEW FORMAT
			switch(options.decisionType){
				case 'submit':
					var self = this;
					var dirtyData;
					this.actions.routeOptionsModal.source.load.component.find('templates_propertiesForms_routeOptionsForm', function(routeOptionsComponent){
						var validationResult = {};
						routeOptionsComponent.onBeforeSubmit(true, routeOptionsComponent.getDirties(), validationResult);
						dirtyData = routeOptionsComponent.model.dirtyFields;
						if(dirtyData.data && dirtyData.data.attributes){
							var primaryKey = 'id';
							if(routeOptionsComponent.model.resourceAttributeMapping.primaryKey){
								primaryKey = routeOptionsComponent.model.resourceAttributeMapping.primaryKey;
							}

							if(dirtyData.data.attributes[primaryKey]){
								delete dirtyData.data.attributes[primaryKey];
							}

							if(utils.collectionSize(dirtyData.data.attributes) <= 0){
								dirtyData = undefined;
							}
						}
						else {
							dirtyData = undefined;
						}
					});

					if(dirtyData){
						// be sure that the dirty data lives longer than a modal reopen process
						utils.refMerge(this.model.options, dirtyData);

						this.parent(function(parentComponent){
							// set dirty by hand
							parentComponent.setDirty();

							// set dirty fields
							utils.refMerge(parentComponent.model.dirtyFields, dirtyData);

							// be sure that the right primaryKey is set within the parent form
							if(!parentComponent.config.creationMode){
								parentComponent.trigger('onChildChanged', {
									fieldCode:  'primaryKey'
								});
							}
						});
					}
					else {
						this.parent(function(parentComponent) {
							// set dirty by hand => set clean by hand
							parentComponent.setClean();
						});
					}
					break;

				case 'cancel':
					// do nothing
					break;

				default:
					// TODO: ERROR;
			}

			await this.actions.routeOptionsModal.source.load.component.hide();
		}
	}
};